export default __webpack_public_path__ + "static/media/bihada-factory-mission-03.94b67d68.jpg";